var map = {
	"./achievements/commun-achiev.png": 433,
	"./achievements/rare-achiev.png": 434,
	"./achievements/very-rare-achiev.png": 435,
	"./hats/cap-brazil.png": 436,
	"./hats/cap-china.png": 437,
	"./hats/cap-greece.png": 438,
	"./hats/cap-sri-lanka.png": 439,
	"./hats/hat-brazil.png": 440,
	"./hats/hat-china.png": 441,
	"./hats/hat-greece.png": 442,
	"./hats/hat-sri-lanka.png": 443,
	"./hats/special-adventour.png": 444,
	"./hats/special-crown.png": 445,
	"./hats/special-indiana.png": 446,
	"./items/alcohol-in-gel.png": 370,
	"./items/analgesic.png": 371,
	"./items/apple.png": 372,
	"./items/bandages.png": 373,
	"./items/mask.png": 374,
	"./items/repellent.png": 375,
	"./items/sandwich.png": 376,
	"./items/sedative.png": 377,
	"./items/sunscreen.png": 378,
	"./items/water.png": 379,
	"./landpage-about.png": 361,
	"./landpage-login.png": 359,
	"./landpage-matilde.png": 358,
	"./landpage-register.png": 360,
	"./matilde-faces/matilde-angry.png": 126,
	"./matilde-faces/matilde-bored.png": 127,
	"./matilde-faces/matilde-cap-brazil-angry.png": 128,
	"./matilde-faces/matilde-cap-brazil-bored.png": 129,
	"./matilde-faces/matilde-cap-brazil-happy.png": 130,
	"./matilde-faces/matilde-cap-brazil-hello.png": 131,
	"./matilde-faces/matilde-cap-brazil-impressed.png": 132,
	"./matilde-faces/matilde-cap-brazil-normal.png": 133,
	"./matilde-faces/matilde-cap-brazil-sad.png": 134,
	"./matilde-faces/matilde-cap-brazil-scary.png": 135,
	"./matilde-faces/matilde-cap-brazil-sleepy.png": 136,
	"./matilde-faces/matilde-cap-brazil-thinking.png": 137,
	"./matilde-faces/matilde-cap-brazil-tired.png": 138,
	"./matilde-faces/matilde-cap-china-angry.png": 139,
	"./matilde-faces/matilde-cap-china-bored.png": 140,
	"./matilde-faces/matilde-cap-china-happy.png": 141,
	"./matilde-faces/matilde-cap-china-hello.png": 142,
	"./matilde-faces/matilde-cap-china-impressed.png": 143,
	"./matilde-faces/matilde-cap-china-normal.png": 144,
	"./matilde-faces/matilde-cap-china-sad.png": 145,
	"./matilde-faces/matilde-cap-china-scary.png": 146,
	"./matilde-faces/matilde-cap-china-sleepy.png": 147,
	"./matilde-faces/matilde-cap-china-thinking.png": 148,
	"./matilde-faces/matilde-cap-china-tired.png": 149,
	"./matilde-faces/matilde-cap-greece-angry.png": 150,
	"./matilde-faces/matilde-cap-greece-bored.png": 151,
	"./matilde-faces/matilde-cap-greece-happy.png": 152,
	"./matilde-faces/matilde-cap-greece-hello.png": 153,
	"./matilde-faces/matilde-cap-greece-impressed.png": 154,
	"./matilde-faces/matilde-cap-greece-normal.png": 155,
	"./matilde-faces/matilde-cap-greece-sad.png": 156,
	"./matilde-faces/matilde-cap-greece-scary.png": 157,
	"./matilde-faces/matilde-cap-greece-sleepy.png": 158,
	"./matilde-faces/matilde-cap-greece-thinking.png": 159,
	"./matilde-faces/matilde-cap-greece-tired.png": 160,
	"./matilde-faces/matilde-cap-sri-lanka-angry.png": 161,
	"./matilde-faces/matilde-cap-sri-lanka-bored.png": 162,
	"./matilde-faces/matilde-cap-sri-lanka-happy.png": 163,
	"./matilde-faces/matilde-cap-sri-lanka-hello.png": 164,
	"./matilde-faces/matilde-cap-sri-lanka-impressed.png": 165,
	"./matilde-faces/matilde-cap-sri-lanka-normal.png": 166,
	"./matilde-faces/matilde-cap-sri-lanka-sad.png": 167,
	"./matilde-faces/matilde-cap-sri-lanka-scary.png": 168,
	"./matilde-faces/matilde-cap-sri-lanka-sleepy.png": 169,
	"./matilde-faces/matilde-cap-sri-lanka-thinking.png": 170,
	"./matilde-faces/matilde-cap-sri-lanka-tired.png": 171,
	"./matilde-faces/matilde-happy.png": 172,
	"./matilde-faces/matilde-hat-brazil-angry.png": 173,
	"./matilde-faces/matilde-hat-brazil-bored.png": 174,
	"./matilde-faces/matilde-hat-brazil-happy.png": 175,
	"./matilde-faces/matilde-hat-brazil-hello.png": 176,
	"./matilde-faces/matilde-hat-brazil-impressed.png": 177,
	"./matilde-faces/matilde-hat-brazil-normal.png": 178,
	"./matilde-faces/matilde-hat-brazil-sad.png": 179,
	"./matilde-faces/matilde-hat-brazil-scary.png": 180,
	"./matilde-faces/matilde-hat-brazil-sleepy.png": 181,
	"./matilde-faces/matilde-hat-brazil-thinking.png": 182,
	"./matilde-faces/matilde-hat-brazil-tired.png": 183,
	"./matilde-faces/matilde-hat-china-angry.png": 184,
	"./matilde-faces/matilde-hat-china-bored.png": 185,
	"./matilde-faces/matilde-hat-china-happy.png": 186,
	"./matilde-faces/matilde-hat-china-hello.png": 187,
	"./matilde-faces/matilde-hat-china-impressed.png": 188,
	"./matilde-faces/matilde-hat-china-normal.png": 189,
	"./matilde-faces/matilde-hat-china-sad.png": 190,
	"./matilde-faces/matilde-hat-china-scary.png": 191,
	"./matilde-faces/matilde-hat-china-sleepy.png": 192,
	"./matilde-faces/matilde-hat-china-thinking.png": 193,
	"./matilde-faces/matilde-hat-china-tired.png": 194,
	"./matilde-faces/matilde-hat-greece-angry.png": 195,
	"./matilde-faces/matilde-hat-greece-bored.png": 196,
	"./matilde-faces/matilde-hat-greece-happy.png": 197,
	"./matilde-faces/matilde-hat-greece-hello.png": 198,
	"./matilde-faces/matilde-hat-greece-impressed.png": 199,
	"./matilde-faces/matilde-hat-greece-normal.png": 200,
	"./matilde-faces/matilde-hat-greece-sad.png": 201,
	"./matilde-faces/matilde-hat-greece-scary.png": 202,
	"./matilde-faces/matilde-hat-greece-sleepy.png": 203,
	"./matilde-faces/matilde-hat-greece-thinking.png": 204,
	"./matilde-faces/matilde-hat-greece-tired.png": 205,
	"./matilde-faces/matilde-hat-sri-lanka-angry.png": 206,
	"./matilde-faces/matilde-hat-sri-lanka-bored.png": 207,
	"./matilde-faces/matilde-hat-sri-lanka-happy.png": 208,
	"./matilde-faces/matilde-hat-sri-lanka-hello.png": 209,
	"./matilde-faces/matilde-hat-sri-lanka-impressed.png": 210,
	"./matilde-faces/matilde-hat-sri-lanka-normal.png": 211,
	"./matilde-faces/matilde-hat-sri-lanka-sad.png": 212,
	"./matilde-faces/matilde-hat-sri-lanka-scary.png": 213,
	"./matilde-faces/matilde-hat-sri-lanka-sleepy.png": 214,
	"./matilde-faces/matilde-hat-sri-lanka-thinking.png": 215,
	"./matilde-faces/matilde-hat-sri-lanka-tired.png": 216,
	"./matilde-faces/matilde-hello.png": 217,
	"./matilde-faces/matilde-impressed.png": 218,
	"./matilde-faces/matilde-normal.png": 219,
	"./matilde-faces/matilde-sad.png": 220,
	"./matilde-faces/matilde-scary.png": 221,
	"./matilde-faces/matilde-sleepy.png": 222,
	"./matilde-faces/matilde-special-adventour-angry.png": 223,
	"./matilde-faces/matilde-special-adventour-bored.png": 224,
	"./matilde-faces/matilde-special-adventour-happy.png": 225,
	"./matilde-faces/matilde-special-adventour-hello.png": 226,
	"./matilde-faces/matilde-special-adventour-impressed.png": 227,
	"./matilde-faces/matilde-special-adventour-normal.png": 228,
	"./matilde-faces/matilde-special-adventour-sad.png": 229,
	"./matilde-faces/matilde-special-adventour-scary.png": 230,
	"./matilde-faces/matilde-special-adventour-sleepy.png": 231,
	"./matilde-faces/matilde-special-adventour-thinking.png": 232,
	"./matilde-faces/matilde-special-adventour-tired.png": 233,
	"./matilde-faces/matilde-special-crown-angry.png": 234,
	"./matilde-faces/matilde-special-crown-bored.png": 235,
	"./matilde-faces/matilde-special-crown-happy.png": 236,
	"./matilde-faces/matilde-special-crown-hello.png": 237,
	"./matilde-faces/matilde-special-crown-impressed.png": 238,
	"./matilde-faces/matilde-special-crown-normal.png": 239,
	"./matilde-faces/matilde-special-crown-sad.png": 240,
	"./matilde-faces/matilde-special-crown-scary.png": 241,
	"./matilde-faces/matilde-special-crown-sleepy.png": 242,
	"./matilde-faces/matilde-special-crown-thinking.png": 243,
	"./matilde-faces/matilde-special-crown-tired.png": 244,
	"./matilde-faces/matilde-special-indiana-angry.png": 245,
	"./matilde-faces/matilde-special-indiana-bored.png": 246,
	"./matilde-faces/matilde-special-indiana-happy.png": 247,
	"./matilde-faces/matilde-special-indiana-hello.png": 248,
	"./matilde-faces/matilde-special-indiana-impressed.png": 249,
	"./matilde-faces/matilde-special-indiana-normal.png": 250,
	"./matilde-faces/matilde-special-indiana-sad.png": 251,
	"./matilde-faces/matilde-special-indiana-scary.png": 252,
	"./matilde-faces/matilde-special-indiana-sleepy.png": 253,
	"./matilde-faces/matilde-special-indiana-thinking.png": 254,
	"./matilde-faces/matilde-special-indiana-tired.png": 255,
	"./matilde-faces/matilde-thinking.png": 256,
	"./matilde-faces/matilde-tired.png": 257,
	"./menu-achievements.png": 557,
	"./menu-album.png": 558,
	"./menu-hats.png": 559,
	"./menu-inventory.png": 560,
	"./menu-items.png": 561,
	"./menu-social.png": 562,
	"./menu-travel.png": 563,
	"./menu-worldnews.png": 564,
	"./mundo-em-noticias/mundo-em-noticias-end.png": 447,
	"./mundo-em-noticias/mundo-em-noticias-start.png": 448,
	"./narrative/brazil/photo/lk_photo_templo_gangaramaya.jpg": 539,
	"./narrative/brazil/puzzle/lk_puzzle_templo_gangaramaya.jpg": 540,
	"./narrative/china/photo/lk_photo_templo_gangaramaya.jpg": 541,
	"./narrative/china/puzzle/lk_puzzle_templo_gangaramaya.jpg": 542,
	"./narrative/cutscene-inicial/matilde-train.png": 380,
	"./narrative/greece/chapters/gc-chapter-1.png": 381,
	"./narrative/greece/chapters/gc-chapter-2.png": 382,
	"./narrative/greece/chapters/gc-chapter-3.png": 383,
	"./narrative/greece/gc-akrotiri.png": 384,
	"./narrative/greece/gc-athena-temple.png": 385,
	"./narrative/greece/gc-athens-arrival.png": 386,
	"./narrative/greece/gc-barco.png": 387,
	"./narrative/greece/gc-beach-bad.png": 388,
	"./narrative/greece/gc-beach-good.png": 389,
	"./narrative/greece/gc-beach-so-so.png": 390,
	"./narrative/greece/gc-breakfast-bad.png": 391,
	"./narrative/greece/gc-breakfast-good.png": 392,
	"./narrative/greece/gc-bus-happy.png": 393,
	"./narrative/greece/gc-bus-mad.png": 394,
	"./narrative/greece/gc-bus-stop.png": 395,
	"./narrative/greece/gc-dionisio.png": 396,
	"./narrative/greece/gc-hotel-lobby.png": 397,
	"./narrative/greece/gc-hotel-room.png": 398,
	"./narrative/greece/gc-hotel-room2.png": 399,
	"./narrative/greece/gc-hotel.png": 400,
	"./narrative/greece/gc-journey.png": 401,
	"./narrative/greece/gc-kolonaki.png": 402,
	"./narrative/greece/gc-lisbon-sight.png": 403,
	"./narrative/greece/gc-plaka-bad.png": 404,
	"./narrative/greece/gc-plaka-good.png": 405,
	"./narrative/greece/gc-recepcionist.png": 406,
	"./narrative/greece/gc-restaurant.png": 407,
	"./narrative/greece/gc-street-bad.png": 408,
	"./narrative/greece/gc-street-good.png": 409,
	"./narrative/greece/gc-taxi-bags.png": 410,
	"./narrative/greece/gc-taxi-ride.png": 411,
	"./narrative/greece/gc-taxi.png": 412,
	"./narrative/greece/photo/gc-athens-beach.png": 413,
	"./narrative/greece/photo/gc-partenon-end.png": 414,
	"./narrative/greece/photo/gc-partenon.png": 415,
	"./narrative/greece/photo/gc-souvlaki.png": 416,
	"./narrative/greece/photo/gc-sunset-oia.png": 417,
	"./narrative/greece/puzzle/gc-puzzle-acropole.png": 418,
	"./narrative/greece/puzzle/gc-puzzle-boat-view.jpg": 543,
	"./narrative/mountain-view.jpg": 544,
	"./narrative/puzzle.png": 419,
	"./narrative/quizz.png": 420,
	"./narrative/sri-lanka/mountain-view.png": 421,
	"./narrative/sri-lanka/photo/lk-cargills-store.png": 422,
	"./narrative/sri-lanka/photo/lk-old-dutch-hospital.png": 423,
	"./narrative/sri-lanka/photo/lk-old-galle-buck.png": 424,
	"./narrative/sri-lanka/photo/lk-templo-gangaramaya.jpg": 545,
	"./narrative/sri-lanka/puzzle/lk-puzzle-cargills-main_store.png": 425,
	"./narrative/sri-lanka/puzzle/lk-puzzle-templo-gangaramaya.jpg": 546,
	"./narrative/wordsearch.png": 426,
	"./others/camera.png": 427,
	"./others/map.png": 304,
	"./others/none.png": 565,
	"./others/question_mark.jpg": 569,
	"./travel-responsive.png": 566
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 450;